// Add founder photos later: put files in /public/images/founders/ and set photo, e.g. "/images/founders/ahmed.jpg".
export const FOUNDERS = [
  { id: "ahmed", name: "Ahmed", photo: "" },
  { id: "tambi", name: "Tambi", photo: "" },
  { id: "albros", name: "Albros", photo: "" },
];
